import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnDestroy, ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { GisToolsService } from '../../../services/gis-tools.service';
import { LayerService } from '../../../services/layer.service';
import { SpatialQueryService } from '../../../services/spatialQuery.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
/** Geographic Filter Component */
var GeographicFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GeographicFilterComponent, _super);
    function GeographicFilterComponent(_vcr, changeDetectorRef, gisToolsService, layerApi, layerService, spatialQueryService, toSqlStringService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.gisToolsService = gisToolsService;
        _this.layerApi = layerApi;
        _this.layerService = layerService;
        _this.spatialQueryService = spatialQueryService;
        _this.toSqlStringService = toSqlStringService;
        _this.boundarySource = 'system';
        _this.selectedLayerId = 0;
        _this.selectedFeatures = [];
        _this.runSpatialQueryOnSketchComplete = true;
        _this.reactivateSketchOnSketchComplete = true;
        _this.spatialQuerySelection = false;
        _this.disableField = false;
        _this.resetComponent = function () {
            _this.reset();
        };
        _this.updateLayerOnApply = true;
        _this.onfeatureschanged = new EventEmitter();
        _this.onboundarysourcechanged = new EventEmitter();
        _this.selectedGeometryChange = new EventEmitter();
        _this.onapply = new EventEmitter();
        _this.onapplyLayer = new EventEmitter();
        _this.ondone = new EventEmitter();
        _this.ondrawcomplete = new EventEmitter();
        _this.ondraw = new EventEmitter();
        _this._isActivated = false;
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.lassoTool) return [3 /*break*/, 2];
                        this.lassoTool.containerElement = this.containerElement || this.hostElement;
                        return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        if (!this._isActivated) {
                            this.lassoTool.oncomplete.subscribe(function () {
                                _this.lassoComplete();
                            });
                            this._isActivated = true;
                            this.lassoTool.drawEnd.subscribe(function (data) {
                                _this.ondrawcomplete.emit(data);
                                _this.onboundarysourcechanged.emit(null);
                            });
                        }
                        this.changeDetectorRef.detectChanges();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.applySpatialFilterToEsriLayers = function (esriLayers, geometries) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1, _a, dynamicLayerSpatialLayers, results, results_1, results_1_1, result;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dynamicLayerSpatialLayers = esriLayers.map(function (x) { return _this.spatialQueryService.getIDynamicLayerSpatialFromLayer(x); });
                        return [4 /*yield*/, this.spatialQueryService.spatialQuery(true, dynamicLayerSpatialLayers, null, null, null, geometries)];
                    case 1:
                        results = _b.sent();
                        try {
                            for (results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                result = results_1_1.value;
                                this.workingGuid = result.guid;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.applyFilterChangeToLayer();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.registerEvent('onapply', _this.onapply);
        _this.registerEvent('onapplyLayer', _this.onapplyLayer);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('ondrawcomplete', _this.ondrawcomplete);
        _this.registerEvent('ondraw', _this.ondraw);
        _this.registerEvent('onfeatureschanged', _this.onfeatureschanged);
        _this.registerEvent('onboundarysourcechanged', _this.onboundarysourcechanged);
        _this.registerEvent('onselectedgeometrychange', _this.selectedGeometryChange);
        return _this;
    }
    Object.defineProperty(GeographicFilterComponent.prototype, "isActivated", {
        get: function () {
            return this._isActivated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeographicFilterComponent.prototype, "showCountySelect", {
        get: function () {
            return this.selectedLayerId && this.boundaryTypes &&
                this.selectedLayerId === this.getBoundaryTypeByKey('municipality').layerId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeographicFilterComponent.prototype, "showFeatureSelect", {
        get: function () {
            return this.selectedLayerId && (!this.showCountySelect || this.selectedCountyCode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeographicFilterComponent.prototype, "features", {
        get: function () {
            if (this.selectedLayerId > 0) {
                return this.getSelectedBoundaryType().features;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeographicFilterComponent.prototype, "existingGuidFromLayers", {
        get: function () {
            return this.getExistingGuidFromLayers();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeographicFilterComponent.prototype, "boundaryFeaturesAreSelected", {
        get: function () {
            return this.boundarySource === 'system' && !this.existingGuidFromLayers && this.selectedFeatures && this.selectedFeatures.length;
        },
        enumerable: true,
        configurable: true
    });
    GeographicFilterComponent.prototype.getExistingGuidFromLayers = function () {
        var _this = this;
        if (this.esriLayers && this.esriLayers.length && this.esriLayers.length > 0) {
            var results = this.esriLayers.filter(function (x) { return x && x.mapcoreProps && x.mapcoreProps.query && _this.getGuidIfExistsAnywhere(x.mapcoreProps.query); });
            if (results.length) {
                var firstLayer = results[0];
                if (firstLayer.mapcoreProps && firstLayer.mapcoreProps.query) {
                    return this.getGuidIfExistsAnywhere(firstLayer.mapcoreProps.query);
                }
            }
        }
        return null;
    };
    GeographicFilterComponent.prototype.getGuidIfExistsAnywhere = function (query) {
        var _this = this;
        if (query) {
            if (this.getGuidIfExistsInRoot(query)) {
                return this.getGuidIfExistsInRoot(query);
            }
            else if (query.subqueries) {
                var foundGuidQueries = query.subqueries.filter(function (x) { return _this.getGuidIfExistsInRoot(x); });
                if (foundGuidQueries.length && foundGuidQueries.length > 0) {
                    return foundGuidQueries[0].value;
                }
            }
        }
        return null;
    };
    GeographicFilterComponent.prototype.getGuidIfExistsInRoot = function (query) {
        if (query.operator && query.operator.indexOf('GUID') >= 0) {
            return query.value;
        }
    };
    GeographicFilterComponent.prototype.ngOnDestroy = function () {
        this.boundarySource = 'system';
        this.reset();
    };
    GeographicFilterComponent.prototype.lassoComplete = function () {
        this.workingGuid = this.lassoTool.guid;
        this.changeDetectorRef.detectChanges();
    };
    GeographicFilterComponent.prototype.reset = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //this.boundarySource = 'system';
                        this.lassoTool.deactivate();
                        this.workingGuid = this.existingGuidFromLayers;
                        this.selectedLayerId = 0;
                        this.selectedCountyCode = null;
                        this.counties = null;
                        this.boundaryTypes = [];
                        this.selectedFeatures = [];
                        this.populateBoundaryTypes();
                        return [4 /*yield*/, this.populateBoundaryFeatures()];
                    case 1:
                        _a.sent();
                        this.populateCountyArray();
                        this.applyBoundaryTypeFeatureDisplayText();
                        this.selectedGeometryChange.emit({ geometryString: null });
                        return [2 /*return*/];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.populateBoundaryTypes = function () {
        this.boundaryTypes = [];
        this.addBoundaryType('county', 'counties', 'County Boundaries', function (x) { return x.countyCode + " - " + x.name; });
        this.addBoundaryType('district', 'districts', 'District Boundaries', function (x) { return "District - " + x.districtNumber; });
        this.addBoundaryType('municipality', 'municipalities', 'Municipality Boundaries', function (x) { return x.name + " - " + x.municipalityCode; });
        this.addBoundaryType('senateDistrict', 'pasenatedistricts', 'PA Senate Districts', function (x) { return "District " + x.legislativeDistrictNumber + " - " + x.lastName + " " + x.firstName; });
        this.addBoundaryType('houseDistrict', 'pahousedistricts', 'PA House Districts', function (x) { return "District " + x.legislativeDistrictNumber + " - " + x.lastName + " " + x.firstName; });
        this.addBoundaryType('congressDistrict', 'uscongressionaldistricts', 'US Congress Districts', function (x) { return "District " + x.legislativeDistrictNumber + " - " + x.lastName + " " + x.firstName; });
        this.addBoundaryType('assistantAreasWinter', 'assistantAreasWinter', 'Assistant Areas Winter', function (x) { return "Org Code " + x.orgCode + " - SAP Plant " + x.sapPlant + " - " + x.firstName + " " + x.lastName; });
        this.addBoundaryType('assistantAreasSummer', 'assistantAreasSummer', 'Assistant Areas Summer', function (x) { return "Org Code " + x.orgCode + " - SAP Plant " + x.sapPlant + " - " + x.firstName + " " + x.lastName; });
    };
    GeographicFilterComponent.prototype.populateBoundaryFeatures = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.gisToolsService.getAllCounties('objectId, countyCode, name'),
                            this.gisToolsService.getAllDistricts('objectId, districtNumber'),
                            this.gisToolsService.getAllMunicipalities('objectId, countyCode, municipalityCode, municipalityClass, name'),
                            this.gisToolsService.getAllSenateDistricts('objectId, firstName, lastName, legislativeDistrictNumber'),
                            this.gisToolsService.getAllHouseDistricts('objectId, firstName, lastName, legislativeDistrictNumber'),
                            this.gisToolsService.getAllCongressionalDistricts('objectId, firstName, lastName, legislativeDistrictNumber'),
                            this.getAssistAreasForWinter(),
                            this.getAssistAreasForSummer()
                        ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 8]), this.getBoundaryTypeByKey('county').features = _a[0], this.getBoundaryTypeByKey('district').features = _a[1], this.getBoundaryTypeByKey('municipality').features = _a[2], this.getBoundaryTypeByKey('senateDistrict').features = _a[3], this.getBoundaryTypeByKey('houseDistrict').features = _a[4], this.getBoundaryTypeByKey('congressDistrict').features = _a[5], this.getBoundaryTypeByKey('assistantAreasWinter').features = _a[6], this.getBoundaryTypeByKey('assistantAreasSummer').features = _a[7];
                        this.sortFeaturesByAProperty('county', 'countyCode');
                        this.sortFeaturesByAProperty('district', 'districtNumber');
                        this.sortFeaturesByAProperty('municipality', 'name');
                        this.sortFeaturesByAProperty('senateDistrict', 'lastName');
                        this.sortFeaturesByAProperty('houseDistrict', 'lastName');
                        this.sortFeaturesByAProperty('congressDistrict', 'lastName');
                        this.sortFeaturesByAProperty('assistantAreasWinter', 'orgCode');
                        this.sortFeaturesByAProperty('assistantAreasSummer', 'orgCode');
                        return [2 /*return*/];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.setUseSystemBoundary = function () {
        this.boundarySource = 'system';
        this.onboundarysourcechanged.emit(this.boundarySource);
        this.lassoTool.clearFeatureResults();
        this.lassoTool.deactivate();
    };
    GeographicFilterComponent.prototype.setDrawBoundaryOnMap = function () {
        this.lassoTool.deactivate();
        this.boundarySource = 'draw';
        this.onboundarysourcechanged.emit(this.boundarySource);
        this.lassoTool.mapView = this.mapView;
        this.lassoTool.esriLayers = this.esriLayers;
        this.lassoTool.spatialQueryType = 'geoprocessing';
        this.lassoTool.runSpatialQueryOnSketchComplete = this.runSpatialQueryOnSketchComplete;
        this.lassoTool.reactivateSketchOnSketchComplete = false;
        this.lassoTool.clearFeatureResults();
        this.lassoTool.activate();
        this.ondraw.emit(true);
    };
    GeographicFilterComponent.prototype.populateCountyArray = function () {
        var e_2, _a;
        this.counties = [];
        try {
            for (var _b = tslib_1.__values(this.getBoundaryTypeByKey('county').features), _c = _b.next(); !_c.done; _c = _b.next()) {
                var feature = _c.value;
                var county = feature;
                this.counties.push({ countyCode: county.countyCode, name: county.name });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    GeographicFilterComponent.prototype.applyBoundaryTypeFeatureDisplayText = function () {
        var e_3, _a;
        try {
            for (var _b = tslib_1.__values(this.boundaryTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var boundaryType = _c.value;
                this.applyDisplayTextToThisBoundaryType(boundaryType);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    GeographicFilterComponent.prototype.applyDisplayTextToThisBoundaryType = function (boundaryType) {
        var e_4, _a;
        if (boundaryType.getDisplayTextFunc) {
            try {
                for (var _b = tslib_1.__values(boundaryType.features), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var feature = _c.value;
                    feature.displayText = boundaryType.getDisplayTextFunc(feature);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
    };
    GeographicFilterComponent.prototype.addBoundaryType = function (key, apiQueryName, displayText, getDisplayTextFunc) {
        if (getDisplayTextFunc === void 0) { getDisplayTextFunc = null; }
        var boundaryType = { key: key, displayText: displayText, apiQueryName: apiQueryName, getDisplayTextFunc: getDisplayTextFunc, features: [] };
        boundaryType.layerId = this.spatialQueryService.getLayerIdByName(key);
        this.boundaryTypes.push(boundaryType);
    };
    GeographicFilterComponent.prototype.layerIdChanged = function () {
        this.selectedFeatures = [];
        this.emitSelectedFeatures();
        this.changeDetectorRef.detectChanges();
    };
    GeographicFilterComponent.prototype.applySystemBoundaryFilter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedBoundaryType, geometryString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedBoundaryType = this.getSelectedBoundaryType();
                        return [4 /*yield*/, this.spatialQueryService.getGeometry(this.selectedFeatures, selectedBoundaryType)];
                    case 1:
                        geometryString = _a.sent();
                        if (!(this.esriLayers && this.esriLayers.length && this.esriLayers.length > 0)) return [3 /*break*/, 3];
                        this.ondone.emit({ geometryString: geometryString });
                        return [4 /*yield*/, this.applySpatialFilterToEsriLayers(this.esriLayers, [geometryString])];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        Promise.resolve(this.selectedGeometryChange.emit({ geometryString: geometryString }));
                        this.ondone.emit({ geometryString: geometryString });
                        _a.label = 4;
                    case 4:
                        this.onapply.emit({ id: this.layerId, geometryStrings: [geometryString], esriLayerId: this.esriLayerId });
                        return [2 /*return*/];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.applyFilterChangeToLayer = function () {
        this.updateLayerWithGeographicFilter();
        this.lassoTool.clearFeatureResults();
        this.lassoTool.deactivate();
        var data = { query: this.query };
        this.ondone.emit(data);
        if (this.updateLayerOnApply) {
            this.onapplyLayer.emit({ id: this.layerId.toString(), data: data });
        }
    };
    GeographicFilterComponent.prototype.removeGeographicFilter = function () {
        this.updateLayerWithGeographicFilter();
        this.clearExistingSpatialFilter();
    };
    GeographicFilterComponent.prototype.updateLayerWithGeographicFilter = function () {
        var e_5, _a;
        try {
            for (var _b = tslib_1.__values(this.esriLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var esriLayer = _c.value;
                if (this.workingGuid) {
                    var queryWithGuid = this.spatialQueryService.getGuidQuery(this.workingGuid);
                    this.query = this.toSqlStringService.addFilter(esriLayer.mapcoreProps.query, queryWithGuid);
                }
                else {
                    this.query = this.getQueryWithGuidRemoved(esriLayer);
                }
                this.layerService.updateLayerFilter(esriLayer, this.query);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    GeographicFilterComponent.prototype.clearExistingSpatialFilter = function () {
        this.workingGuid = null;
        this.updateLayerWithGeographicFilter();
        if (this.boundarySource === 'draw') {
            this.lassoTool.clearFeatureResults();
            this.lassoTool.activate();
        }
        this.changeDetectorRef.detectChanges();
    };
    GeographicFilterComponent.prototype.getQueryWithGuidRemoved = function (esriLayer) {
        var _this = this;
        var mapcoreProps = esriLayer.mapcoreProps;
        if (mapcoreProps && mapcoreProps.query) {
            var layerQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(mapcoreProps.query);
            if (this.getGuidIfExistsInRoot(layerQuery)) {
                return {};
            }
            else if (layerQuery.subqueries) {
                layerQuery.subqueries = layerQuery.subqueries.filter(function (x) { return !_this.getGuidIfExistsInRoot(x); });
            }
            return layerQuery;
        }
    };
    GeographicFilterComponent.prototype.selectedCountyChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var municipalityBoundaryType, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        municipalityBoundaryType = this.getBoundaryTypeByKey('municipality');
                        this.selectedFeatures = [];
                        municipalityBoundaryType.features = [];
                        this.emitSelectedFeatures();
                        this.changeDetectorRef.detectChanges();
                        _a = municipalityBoundaryType;
                        return [4 /*yield*/, this.gisToolsService.getMunicipalitiesByCounty(this.selectedCountyCode, 'objectId, countyCode, municipalityCode, municipalityClass, name')];
                    case 1:
                        _a.features =
                            _b.sent();
                        this.applyDisplayTextToThisBoundaryType(municipalityBoundaryType);
                        this.emitSelectedFeatures();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.cancel = function () {
        this.lassoTool.clearFeatureResults();
        this.reset();
        if (this.esriLayers && this.esriLayers.length && this.esriLayers.length > 0) {
            this.ondone.emit(null);
        }
        else {
            this.selectedGeometryChange.emit({ geometryString: null });
            this.onapply.emit({ id: this.layerId, geometryStrings: [null], esriLayerId: this.esriLayerId });
        }
    };
    GeographicFilterComponent.prototype.selectedFeaturesChanged = function () {
        this.emitSelectedFeatures();
    };
    GeographicFilterComponent.prototype.emitSelectedFeatures = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedBoundaryType, geometryString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedBoundaryType = this.getSelectedBoundaryType();
                        return [4 /*yield*/, this.spatialQueryService.getGeometry(this.selectedFeatures, selectedBoundaryType)];
                    case 1:
                        geometryString = _a.sent();
                        this.onfeatureschanged.emit({ layerId: this.selectedLayerId, features: this.selectedFeatures, boundaryType: this.getSelectedBoundaryType(), geometryString: geometryString });
                        this.selectedGeometryChange.emit({ geometryString: geometryString });
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.getBoundaryTypeByKey = function (key) {
        return this.boundaryTypes.filter(function (x) { return x.key === key; })[0];
    };
    GeographicFilterComponent.prototype.getSelectedBoundaryType = function () {
        return this.getBoundaryTypeByLayerId(this.selectedLayerId);
    };
    GeographicFilterComponent.prototype.getBoundaryTypeByLayerId = function (layerId) {
        return this.boundaryTypes.filter(function (x) { return x.layerId === layerId; })[0];
    };
    GeographicFilterComponent.prototype.sortFeaturesByAProperty = function (key, prop) {
        var features = this.getBoundaryTypeByKey(key).features;
        this.getBoundaryTypeByKey(key).features = this.gisToolsService.orderBy(features, prop);
    };
    GeographicFilterComponent.prototype.getAssistAreasForWinter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getData(this.spatialQueryService.getLayerIdByName('assistantAreasWinter'), ['objectid', 'org_code', 'sap_plant', 'first_name_shift_a', 'last_name_shift_a'], { field: 'sap_plant', operator: 'IS NOT NULL' })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.map(function (x) { return _this.getAssistantAreaFromDataResult(x); })];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.getAssistAreasForSummer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getData(this.spatialQueryService.getLayerIdByName('assistantAreasSummer'), ['objectid', 'org_code', 'sap_plant', 'first_name', 'last_name'], { field: 'sap_plant', operator: 'IS NOT NULL' })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.map(function (x) { return _this.getAssistantAreaFromDataResult(x); })];
                }
            });
        });
    };
    GeographicFilterComponent.prototype.getAssistantAreaFromDataResult = function (row) {
        var _a = tslib_1.__read(row, 6), objectId = _a[0], orgCode = _a[1], sapPlant = _a[2], firstName = _a[3], lastName = _a[4], geometry = _a[5];
        return {
            objectId: parseInt(objectId, 10),
            orgCode: orgCode,
            sapPlant: sapPlant,
            firstName: firstName,
            lastName: lastName,
            geometry: geometry
        };
    };
    Object.defineProperty(GeographicFilterComponent.prototype, "showApplyButton", {
        get: function () {
            return this.boundarySource === 'draw' && !this.existingGuidFromLayers && this.workingGuid && !this.spatialQuerySelection;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], GeographicFilterComponent.prototype, "runSpatialQueryOnSketchComplete", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], GeographicFilterComponent.prototype, "reactivateSketchOnSketchComplete", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], GeographicFilterComponent.prototype, "updateLayerOnApply", void 0);
    return GeographicFilterComponent;
}(BaseComponent));
export { GeographicFilterComponent };
var BoundaryType = /** @class */ (function () {
    function BoundaryType() {
    }
    return BoundaryType;
}());
export { BoundaryType };
var BoundaryFeature = /** @class */ (function () {
    function BoundaryFeature() {
    }
    return BoundaryFeature;
}());
export { BoundaryFeature };
var AssistantArea = /** @class */ (function (_super) {
    tslib_1.__extends(AssistantArea, _super);
    function AssistantArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssistantArea;
}(BoundaryFeature));
export { AssistantArea };
